'use client';

import { createContext, useContext, PropsWithChildren } from 'react';
import { FrontendUser } from '@trucksmarter/shared';

const UserContext = createContext<FrontendUser | null>(null);

export function useUser() {
  const user = useContext(UserContext);

  if (user === null) {
    throw new Error('useUser has to be used within <UserProvider>');
  }

  return user;
}

interface Props {
  value: FrontendUser;
}

export default function UserProvider(props: PropsWithChildren<Props>) {
  return <UserContext.Provider {...props} />;
}
